const getLabelTarget = (button: HTMLElement): HTMLElement | null => {
    const explicitTarget = button.querySelector("[data-loading-label-target]");

    if (explicitTarget instanceof HTMLElement) {
        return explicitTarget;
    }

    const firstVisibleSpan = button.querySelector("span:not(.sr-only)");

    if (firstVisibleSpan instanceof HTMLElement) {
        return firstVisibleSpan;
    }

    return null;
};

const setDisabled = (button: HTMLElement, disabled: boolean): void => {
    if (disabled) {
        button.setAttribute("disabled", "true");
    } else {
        button.removeAttribute("disabled");
    }
};

export const setButtonLoading = (
    button: HTMLElement | null,
    loadingLabel = "Adding...",
): void => {
    if (button === null) {
        return;
    }

    const labelTarget = getLabelTarget(button);
    const textTarget = labelTarget ?? button;

    if (textTarget.dataset.loadingOriginalText === undefined) {
        textTarget.dataset.loadingOriginalText = textTarget.textContent ?? "";
    }

    textTarget.textContent = loadingLabel;
    button.setAttribute("data-loading", "true");
    button.setAttribute("aria-busy", "true");
    setDisabled(button, true);
};

export const clearButtonLoading = (
    button: HTMLElement | null,
    options: { keepDisabled?: boolean } = {},
): void => {
    if (button === null) {
        return;
    }

    const labelTarget = getLabelTarget(button);
    const textTarget = labelTarget ?? button;
    const originalText = textTarget.dataset.loadingOriginalText;

    if (originalText !== undefined) {
        textTarget.textContent = originalText;
        delete textTarget.dataset.loadingOriginalText;
    }

    button.removeAttribute("data-loading");
    button.removeAttribute("aria-busy");

    if (options.keepDisabled !== true) {
        setDisabled(button, false);
    }
};
